module.exports = __webpack_public_path__ + "pcstatic/img/2.3749532.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/2.png
// module id = n1j6
// module chunks = 34